import cx from 'classnames';
import { useIntl } from 'react-intl';

import { Carousel, useCarousel } from '../../../domains/Layout/Carousel/Carousel';
import { imageLoaderForId } from '../../../domains/Layout/Image/URL/ImageURL';
import { Destination } from '../../../resources/destination/domain/types/destination';
import { useUrlGenerator } from '../../hooks/useUrlGenerator';
import { PickDomain } from '../../utilities/types/PickDomain';
import { DestinationCard } from '../DestinationCard/DestinationCard';

import style from './OtherDestinationSection.module.css';

export { OTHER_DESTINATIONS_SECTION_MAX_ITEMS } from './constants';

type Props = {
    destinations: PickDomain<
        Destination,
        'id' | 'name' | 'slug' | 'coverPicture',
        {
            parentDestination: PickDomain<Destination, 'id'> | null;
        }
    >[];
    title?: string;
};

export function OtherDestinationsSection({ destinations, title }: Props) {
    const destinationsCarousel = useCarousel();
    const { formatMessage } = useIntl();
    const { generatePath } = useUrlGenerator();

    return (
        <>
            <div className={cx(style.title, 'font-l-extrabold')} role="heading" aria-level={2}>
                {title ?? formatMessage({ id: 'global.component.otherDestinationsSection.title' })}
            </div>
            <Carousel
                {...destinationsCarousel}
                slidesVisibleRules={{
                    sm: 2,
                    md: 3,
                    lg: 3,
                    xl: 3,
                    xxl: 3,
                }}
            >
                {destinations.map((destination, index) => {
                    return (
                        <DestinationCard
                            key={destination.id}
                            href={generatePath('destination', {
                                destinationSlug: destination.slug,
                            })}
                            image={{
                                alt: destination.coverPicture.legend,
                                src: destination.coverPicture.id.toString(),
                                loader: imageLoaderForId({
                                    aspectRatio: DestinationCard.PICTURE_RATIO,
                                }),
                                sizes: '(min-width: 1200px) 400px, 300px',
                            }}
                            title={destination.name}
                            trackingInformation={{
                                click: {
                                    destination_id: destination.id,
                                    destination_slug: destination.slug,
                                    block: 'destinations',
                                    card_number: index + 1,
                                    tool_counter: 0,
                                    destination_type: destination.parentDestination
                                        ? 'region'
                                        : 'country',
                                },
                            }}
                        />
                    );
                })}
            </Carousel>
        </>
    );
}
